export const TRANSACTION_KIND = {
  ORDER: 'ORDER',
  RESERVATION: 'RESERVATION',
  ADJUSTMENT: 'ADJUSTMENT',
};

export const PAGE_SIZE = 20;

export const FLYOUT_ID = 'sku-payout-order-flyout';
